import classNames from 'classnames/bind';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

function LogoCarousel({
  src,
  category,
  width,
  height,
}) {
  const imageContainerClassName = cx('image', {
    trusted: category === 'trusted',
    featured: category === 'featured',
    members: category === 'members',
  });

  return (
    <div className={imageContainerClassName}>
      <img
        src={src}
        width={width}
        height={height}
        alt="logo"
      />
    </div>
  );
}

export default withComponentName(LogoCarousel);
